const REGEX_FORWARDSLASH = "^/";
const REGEX_FORWARDWORD = "^[A-Za-z/]+$";

export { REGEX_FORWARDSLASH, REGEX_FORWARDWORD };
